module.exports = __webpack_public_path__ + "static/media/maf-20.0a49ea59.png";